// Add new row to the form
const {v4: uuidv4} = require("uuid"); // Generate unique id for new form rows
// Template for a new form row
// Get template content from hidden textarea
const $template = $('#template')

const $form = $template.closest('form');

function showOrHideDeleteButton() {
    const $removeRowButtons = $form.find('.remove-row')
    if ($removeRowButtons.length === 1) {
        $removeRowButtons.hide()
    } else {
        $removeRowButtons.show()
    }
}

function addRow() {
  let templateContent = '';
  switch ($template[0].tagName) {
      case 'TEXTAREA': templateContent = $template.val(); break;
      case 'TEMPLATE': templateContent = $template.html(); break;
      default:
          console.error('Invalid #template tag. #template must be <template> or <textarea>')
          return;
  }
  const template = jQuery.validator.format($.trim(templateContent));
  $(template(uuidv4())).appendTo(".form__rows");
  updateBikeCount();
  $form.trigger('form:change')
  showOrHideDeleteButton()
}

// Delete a row from the form
function removeRow(e) {
  const rowToRemove = $(e.target).parents(".form__row");
  $(rowToRemove).remove();
  updateBikeCount();
  $form.trigger('form:change')
  showOrHideDeleteButton()
}

// add more rows on click
$("#add").click(function (e) {
  // TODO this implementation can't handle multiple add buttons on one page.
  e.preventDefault();
  addRow();
});

// remove the current row
$(document).on("click", ".remove-row", function (e) {
  removeRow(e);
});

// update bike count
function updateBikeCount() {
  $('[name*="bike-count"]').val($(".form__row").length);
}

function updateTotalValue(e) {
    let $totalValueInput = $(".field__box--totalValue input, .totalValue");
    $totalValueInput.val("");
    // console.log(e);
    let totalValue = 0;
    $(".field__box--currency input").each(function () {
        totalValue += Number($(this).val());
    });
    $totalValueInput.val(totalValue);
    $totalValueInput.blur();
}

$(document).on("input change", ".field__box--currency input", function (e) {
    updateTotalValue(e);
});

$(document).ready(() => {
    showOrHideDeleteButton()
})
